import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminPrescriptionUpdatePage } from './admin-prescription-update';

@NgModule({
  declarations: [
    AdminPrescriptionUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(AdminPrescriptionUpdatePage),
  ],
})
export class AdminPrescriptionUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-prescription-update/admin-prescription-update.module.ts